import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";

import * as yup from "yup";

import api from "~/services/api";
import { handleBlock } from "~/scripts/handleBlock.js";

import { toast } from "react-toastify";

import { Container } from "./styles";

import { getAccountTypes, getBanks } from "~/scripts";

import { Form, Input, Select } from "@rocketseat/unform";
import {
  FaTimes,
  FaAngleRight,
  FaUserAlt,
  FaLandmark,
  FaInfo,
  FaPager,
  FaMoneyCheckAlt,
  FaUsers,
  FaCalendar
} from "react-icons/fa";

export default function FormMissionario({
  cgc,
  agentId,
  agent,
  setAgent,
  edit
}) {
  const profile = useSelector(state => state.user.profile);
  const [block, setBlock] = useState(false);
  const [missionario, setMissionario] = useState({
    agent_id: agentId,
    created_by: profile.id,
    cgc,
    new: true,
    dependents: 0
  });
  const account_types = getAccountTypes(agent.country)

  const banks = getBanks(agent.country)

  useEffect(() => {
    async function loadMissionario() {
      try {
        const response = await api.get("missionarie/?agentId=" + agentId, {
          agentId
        });
        const { data } = response;
        setMissionario({ ...data, new: false });
      } catch(err) {

      }
    }
    loadMissionario();
    setBlock(false);
  }, [agentId, setBlock, block]);

  async function handleSubmit() {
    try {
      const response = missionario.new
        ? await api.post("missionarie/", missionario)
        : await api.put("missionarie/", missionario);

      toast.success(`Dados de Missionário atualizado com sucesso!`, {
        className: "success"
      });
      setAgent({
        ...agent,
        type: agent.type + ",4",
        new: false,
        agent_id: response.data.id
      });
      return;
    } catch (err) {
      toast.error("Por favor, revise os dados!", { className: "error" });
    }
  }

  const agentSchema = yup.object().shape({
    full_name: yup.string().required("Nome obrigatório."),
    short_name: yup.string().required("Apelido obrigatório."),
    // bank: yup.string().required("Banco obrigatório obrigatório"),
    // account_type: yup.string().required("Tipo de conta obrigatório"),
    // agency: yup.string().required(agent.country === "BR" ? "Agência obrigatória" : "R.N. Obrigatório" ),
    // account: yup.string().required(agent.country === "BR" ? "Conta obrigatória" : "Account Number Obrigatório" ),
    // pay_day: yup.string().required("Dia para pagar obrigatório"),
    // inss: yup.string().required("Selecione uma opção")
  });

  return (
    <Container>
      <h1>Dados de Missionário</h1>
      <Form
        initialData={missionario}
        onSubmit={handleSubmit}
        schema={agentSchema}
      >
        <div className="rowInputs">
          <label htmlFor="full_name">
            <div>
              <FaUserAlt size={20} />
              <br />
              Nome
            </div>
            <Input
              name="full_name"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setMissionario({ ...missionario, full_name: e.target.value })
              }
              // placeholder={agent.name}
              maxLength="60"
            />
          </label>
          <label htmlFor="short_name">
            <div>
              <FaUserAlt size={20} />
              <br />
              Apelido
            </div>
            <Input
              name="short_name"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setMissionario({ ...missionario, short_name: e.target.value })
              }
              maxLength="40"
            />
          </label>
        </div>
        <hr />

        <div className="rowInputs">
          {/* <label htmlFor="accounting_code">
            <div>
              <FaBalanceScale size={20} />
              <br />
              C.Contáb.
            </div>
            <Input
              name="accounting_code"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setMissionario({
                  ...missionario,
                  accounting_code: e.target.value
                })
              }
              maxLength="18"
            />
          </label>
          <label htmlFor="tax_nature">
            <div>
              <FaCube size={20} />
              <br />
              Natureza
            </div>
            <Input
              name="tax_nature"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setMissionario({ ...missionario, tax_nature: e.target.value })
              }
            />
          </label> */}
          <label htmlFor="bank">
            <div>
              <FaLandmark size={20} />
              <br />
              Banco
            </div>
            <Select
              options={banks}
              name="bank"
              value={missionario.bank}
              disabled={!edit ? "disabled" : ""}
              onChange={e =>
                setMissionario({ ...missionario, bank: e.target.value })
              }
            />
          </label>
          <label htmlFor="account_type">
            <div>
              <FaInfo size={20} />
              <br />
              Tipo
            </div>
            <Select
              options={account_types}
              name="account_type"
              disabled={!edit ? "disabled" : ""}
              onChange={e =>
                setMissionario({ ...missionario, account_type: e.target.value })
              }
              value={missionario.account_type}
            />
          </label>
        </div>
        <hr />

        <div className="rowInputs">
          <label htmlFor="agency">
            <div>
              <FaPager size={20} />
              <br />
              { agent.country === "BR" ? "Agencia" : "R.N" }
            </div>
            <Input
              name="agency"
              readOnly={!edit ? "readonly" : ""}
              placeholder=""
              value={missionario.agency}
              onChange={e =>
                setMissionario({
                  ...missionario,
                  agency: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              maxLength="40"
            />
          </label>
          {agent.country === "BR" ?
          <label htmlFor="agency_code" className="mini_input">
            <Input
              name="agency_code"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Dígito"
              maxLength="1"
              value={missionario.agency_code}
              onChange={e =>
                setMissionario({
                  ...missionario,
                  agency_code: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
            />
          </label>
          : null }
          <label htmlFor="account">
            <div>
              <FaMoneyCheckAlt size={20} />
              <br />
              { agent.country === "BR" ? "Conta" : "Acc." }
            </div>
            <Input
              name="account"
              readOnly={!edit ? "readonly" : ""}
              placeholder=""
              maxLength="40"
              value={missionario.account}
              onChange={e =>
                setMissionario({
                  ...missionario,
                  account: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
            />
          </label>
          { agent.country === "BR" ?
          <label htmlFor="account_code" className="mini_input">
            <Input
              name="account_code"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Dígito"
              maxLength="1"
              value={missionario.account_code}
              onChange={e =>
                setMissionario({
                  ...missionario,
                  account_code: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
            />
          </label>
           : null }
        </div>
        <hr />

        <div className="rowInputs">
          <label htmlFor="dependents">
            <div>
              <FaUsers size={20} />
              <br />
              Depend.
            </div>
            <Input
              name="dependents"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Nº de dependentes"
              onChange={e =>
                setMissionario({
                  ...missionario,
                  dependents: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              value={missionario.dependents}
              maxLength="2"
            />
          </label>
          <label htmlFor="pay_day">
            <div>
              <FaCalendar size={20} />
              <br />
              Pagto.
            </div>
            <Input
              name="pay_day"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Dia para pagamento"
              maxLength="2"
              value={missionario.pay_day}
              onChange={e =>
                setMissionario({
                  ...missionario,
                  pay_day: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
            />
          </label>
          <label htmlFor="inss">
            <div>
              <FaInfo size={20} />
              <br />
              INSS
            </div>
            <Select
              options={[
                { id: 1, title: "Sim" },
                { id: 2, title: "Não" }
              ]}
              disabled={!edit ? "disabled" : ""}
              name="inss"
              onChange={e =>
                setMissionario({ ...missionario, inss: e.target.value })
              }
              value={missionario.inss}
            />
          </label>
        </div>
        <hr />

        <div
          className="rowInputs"
          style={{ "justify-content": "space-between" }}
        >
          {edit ? (
            <>
              <button
                type="button"
                onClick={() =>
                  handleBlock(
                    missionario.id,
                    missionario.canceled_at,
                    "missionário",
                    "missionarie",
                    setBlock
                  )
                }
                class="btnFinish trash"
                id="btnBlock"
              >
                {missionario.canceled_at ? (
                  <>
                    <FaAngleRight size={16} />
                    &nbsp; Desbloquear missionário
                  </>
                ) : (
                  <>
                    <FaTimes size={16} />
                    &nbsp; Bloquear missionário
                  </>
                )}
              </button>
              <button type="submit" class="btnFinish" id="btnFinish">
                <>
                  {missionario.new ? "Gravar" : "Atualizar"}{" "}
                  <FaAngleRight size={20} />
                </>
              </button>
            </>
          ) : null}
        </div>
      </Form>
    </Container>
  );
}
